import React, { Component } from 'react'
import {
    Redirect,
    Route,
} from 'react-router-dom'

import {
    authedUserConnect,
    withRouter,
} from '../../validator'
import Loader from '../../components/shared/loader'
import OverlayLoader from '../../components/shared/overlay-loader'

@withRouter()
@authedUserConnect()
export class LoggedRoute extends Component {
    /**
     * Render logged route
     *
     * @return {*}
     */
    render() {
        const {
            authedUser,
            busyAuth,
        } = this.props

        if (busyAuth) {
            return <OverlayLoader />
        }

        if (!authedUser) {
            return <Redirect to='/login' />
        }

        if (!authedUser?.approved) {
            return <div>Nemáte zde přístup!</div>
        }

        return <Route {...this.props} />
    }
}
